// angular
import {Component, OnInit, ChangeDetectorRef} from '@angular/core';

// others
import { ActivityDashboardService } from './activity-dashboard.service';
import { AppService } from '../app.service';
import { BaseComponent } from '../shared/base.component';
import { AuthService } from '../core/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from '../shared/base.service';
import { ActivityModel } from './activity.model';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import DurationConstructor = moment.unitOfTime.DurationConstructor;
import {HELP_ACTIVITY_DASHBOARD} from '../shared/constants/help-buttons';
import { PopoverService } from '../shared/popover/popover.service';
import { ClinicsService } from '../clinics/clinics.service';
import { DaterangepickerConfig } from 'ng2-daterangepicker';
import * as _ from 'lodash';

@Component({
    selector: 'app-activity-dashboard',
    styleUrls: ['./activity-dashboard.component.scss'],
    templateUrl: './activity-dashboard.component.html',
    providers: [
        ActivityDashboardService,
        BaseService,
        ClinicsService
        ]
})


export class ActivityDashboardComponent extends BaseComponent implements OnInit {
    datePipe: DatePipe = new DatePipe('en-US');
    format = 'DD.MM.YYYY';

    urlAPI = 'activity';
    sortedColumn = 'official_name';
    order = 'desc';
    paginationHidden = true;

    minDate= moment();
    today= moment();
    year = moment().year();
    dateRangeSelected = 'month';
    dateRangeNumber = new Date().getMonth();
    dateOptionsFilter = {
        from: moment().startOf('month'),
        to: moment().endOf('month'),
    };
    assigneeFilter = [];
    data: any;
    user: any;

    select2Options = {
        multiple: false,
        cssImport: true,
        // matcher: true,
        templateSelection: function(state) {
            if (state['display']) {
                return state[state['display']];
            }
            return state['text'];
        }
    };

    reset = false;
    language = null;
    collapse = [];
    clinics = [];
    allClinic = {
        en_GB : {
            'id': 0,
            'text': 'All customers',
            'created_at': moment().subtract(5, 'years')
        },
        de_CH : {
            'id': 0,
            'text': 'Alle Kund:innen',
            'created_at': moment().subtract(5, 'years')
        }
    };
    languageChanged = true;
    clinicsCollection = [];
    clinicId = 0;
    selectedClinic: any;
    errorMessageText = '';
    poolClinicId = 0;

    readonly tableColumns = [
        ['official_name', 'Name', 'col-xs-2 col-xs-2--overview-table', 'ddl', ''],
        ['completion_rate', 'Completion rate', 'col-xs-2 col-xs-2--overview-table', 'ddl', ''],
        ['accepted_proposal', 'Accepted Proposals', 'col-xs-2 col-xs-2--overview-table', 'text', ''],
        ['symptom_maps', 'Symptom maps', 'col-xs-2 col-xs-2--overview-table', 'text', ''],
        ['unviewed_patient', 'Unviewed maps', 'col-xs-2 col-xs-2--overview-table', 'text', ''],
        ['overdue_questionnaire', 'Overdue SRs', 'col-xs-2 col-xs-2--overview-table', 'text', ''],
        ['last_login', 'Last Login (in days)', 'col-xs-2 col-xs-2--overview-table', 'ddl', ''],
    ];

    readonly tableColumns_2 = [
        ['full_name', 'Name', 'col-xs-2', 'ddl', ''],
        ['send_se', 'Sent SRs', 'col-xs-2', 'ddl', ''],
        ['receive_se', 'Received SRs', 'col-xs-2', 'text', '']
    ];

    readonly tableColumns_3 = [
        ['full_name', 'Name', 'col-xs-2', 'ddl', ''],
        ['reviewed_proposal', 'Reviewed', 'col-xs-2', 'ddl', ''],
        ['accepted_proposal', 'Accepted', 'col-xs-2', 'ddl', ''],
        ['denied_proposal', 'Denied', 'col-xs-2', 'text', ''],
        ['most_selected_diagnosis', 'Most selected diagnosis', 'col-xs-4', 'text', '']
    ];

    readonly tableColumns_repeated_sr = [
        ['full_name', 'Name', 'col-xs-2', 'ddl', ''],
        ['send_repeated_se', 'Triggered', 'col-xs-2', 'ddl', ''],
        ['receive_repeated_se', 'Received', 'col-xs-2', 'ddl', ''],
    ];

    readonly tableColumns_cv = [
        ['full_name', 'Name', 'col-xs-2', 'ddl', ''],
        ['cv_in_progress', 'Started', 'col-xs-2', 'ddl', ''],
        ['cv_done', 'Completed', 'col-xs-2', 'ddl', ''],
    ];

    readonly tableColumns_compare_action = [
        ['full_name', 'Name', 'col-xs-2', 'ddl', ''],
        ['clicked', 'Clicked', 'col-xs-2', 'ddl', ''],
        ['compare_cv_to_cv', 'CV <-> CV', 'col-xs-2', 'ddl', ''],
        ['compare_sr_to_sr', 'SR <-> SR', 'col-xs-2', 'ddl', ''],
        ['compare_cv_to_sr', 'CV <-> SR', 'col-xs-2', 'ddl', ''],
        ['compare_sr_to_cv', 'SR <-> CV', 'col-xs-2', 'ddl', ''],
    ];

    readonly tableColumns_tracking = [
        ['full_name', 'Name', 'col-xs-3', 'ddl', ''],
        ['avg_spent_time', 'Average SR duration', 'col-xs-3', 'ddl', ''],
        ['abort_sr', 'Abort SRs', 'col-xs-3', 'ddl', ''],
        ['export_patient_list', 'Export patient list', 'col-xs-3', 'ddl', ''],
    ];

    readonly tableColumns_download_info = [
        ['full_name', 'Name', 'col-xs-2', 'ddl', ''],
        ['new_register', 'New register', 'col-xs-2', 'ddl', ''],
        ['symptom_map_download', 'Symptom-map generated', 'col-xs-3', 'ddl', ''],
        ['evaluation_report_download', 'Evaluation report generated', 'col-xs-3', 'ddl', ''],
    ];

    readonly tableColumns_service_provider_action = [
        ['diga_name', 'Name', 'col-xs-4', 'ddl', ''],
        ['viewed', 'DIGA viewed', 'col-xs-2', 'ddl', ''],
        ['selected', 'DIGA Selected', 'col-xs-2', 'ddl', ''],
    ];

    readonly filters = [
        ['week', 'Week', 'col-xs-2', 'date', ''],
        ['month', 'Month', 'col-xs-2', 'month', ''],
        ['quarter', 'Quarter', 'col-xs-2', 'quarter', ''],
        ['year', 'Year', 'col-xs-2', 'year', ''],
        ['specified', 'Specific', 'col-xs-2', 'specified', ''],
    ];
    HELP_ACTIVITY_DASHBOARD = HELP_ACTIVITY_DASHBOARD;

    constructor(
        public authService: AuthService,
        public router: Router,
        public baseService: BaseService,
        public service: ActivityDashboardService,
        public appService: AppService,
        public translateService: TranslateService,
        private cdr: ChangeDetectorRef,
        private popoverService : PopoverService,
        private activatedRoute: ActivatedRoute,
        private clinicService : ClinicsService,
        private dateRangeOptions: DaterangepickerConfig
    ) {
        super(authService, router, baseService, appService);
        this.dateRangeOptions.settings = {
            locale: { format: 'DD.MMM.YYYY' },
            autoApply: true,
            showDropdowns: true,
            alwaysShowCalendars: false,
            width: '100%',
            startDate: this.dateOptionsFilter.from,
            endDate: this.today,
            maxDate: this.today
        };

        this.translateService.onLangChange.subscribe(value => {
            this.languageChanged = false;
            this.language = value.lang;

            // Need timeout to re-render select2
            setTimeout(() => {
                this.languageChanged = true;
            }, 500);
        });
    }

    ngOnInit() {
        this.appService.isLoading = true;
        this.searchInfo = new ActivityModel();
        this.url = 'activity-dashboard';
        this.language = localStorage.getItem('language');
        this.user = this.authService.user;

        if (!this.isSupperAdmin) {
            return this.getItems();
        }
        this.activatedRoute.queryParams.subscribe(params => {
            if (params['clinic_id'] && params['clinic_id'] > 0) {
                this.clinicId = parseInt(params['clinic_id']);
            }
        });
        if(!this.isSupperAdmin()){
            let clinic = this.authService.clinic;
            this.clinicId = clinic.id;
            if (clinic.is_default) {
                this.poolClinicId = this.clinicId;
            }
            return this.getItems();
        }
        this.clinicService.getAll().subscribe( (response : any) => {
            this.clinics = response.items;
            if(this.clinics.length){
                this.clinics.forEach( clinic => {
                    this.clinicsCollection.push({
                        'id': clinic.id,
                        'text': clinic.name,
                        'created_at' : clinic.created_at
                    });

                    if (this.clinicId === clinic.id) {
                        this.selectedClinic = clinic;
                    }

                    if (clinic.is_default) {
                        this.poolClinicId = clinic.id;
                    }
                });
            }
            if(!this.clinicId){
                this.selectedClinic = this.clinicsCollection[0];
                this.clinicId = this.selectedClinic.id;
            }
            this.getItems();
        });
    }

    getItems() {
        const pageNum = this.currentPage;
        this.isLoading = true;
        this.errorMessageText = '';

        let filter = 'sort-' + this.sortedColumn + '--order-' + this.order;
        this.search(filter, pageNum);
    }

    getItem(page, index = 0){
        this.service.getItems(this.urlAPI, this.dateOptionsFilter, page, this.itemsPerPage, this.sortedColumn, this.order, this.clinicId,this.searchInfo, index)
            .subscribe(data => {
                    this.setData(data, index);
                    this.isLoading = false;
                    let apiLength = this.service.SUPERADMIN_DASHBOARD.length;
                    if (this.poolClinicId != this.clinicId) {
                        apiLength = apiLength - 2;
                    }
                    if(index === 0){
                        this.popoverService.setHelpContent(data['helpTemplates']);
                    }
                    if(index < apiLength - 1 && this.isSupperAdmin()){
                        index++;
                        return this.getItem(page, index);
                    }
                },
                (error) => {
                    this.errorMessageText = error.error.error;
                    this.isLoading = false;
                });
    }

    search(filters: string, page: number) {
        // set url query parameters
        this.router.navigate([this.url], {
            queryParams: {
                filters: filters,
                clinic_id: this.clinicId
            }
        });

        if (!this.isUpdated && this.items) {
            return;
        } else {
            this.items = [];
            this.isUpdated = false;
        }

       return this.getItem(page);
    }

    setData(data: any, index?: number): void {
        this.items = _.merge(this.items, data);
        this.selectedClinic = data.clinic ? data.clinic : this.clinicsCollection[0];
        this.minDate = this.selectedClinic.created_at;
        this.dateRangeOptions.settings.minDate = {
            year: moment(this.minDate).year(),
            month: moment(this.minDate).month(),
            day: moment(this.minDate).date()
        }
    }

    showData(item, column) {
        const fnName = 'get' + column.split('_').map(function capitalize(part) {
            return part.charAt(0).toUpperCase() + part.slice(1);
        }).join('');

        if (this[fnName]) {
            return this[fnName](item);
        }

        return '';
    }

    public multipleChanged(data: {value: string[]}, filterType) {
        this.currentPage = 1;

        const filteredData = data.value.join(',');
        if (filteredData === this.searchInfo[filterType]) {
            return false;
        }
        this.searchInfo[filterType] = filteredData;
        this.isUpdated = true;
        this.getItems();
    }

    onDateChanged(event, filterType, type) {
        if (!event.formatted) {
            return;
        }
        let beginDate = event.beginJsDate;
        let endDate = event.endJsDate;

        this.dateOptionsFilter.from = moment(new Date(beginDate));
        this.dateOptionsFilter.to = moment(new Date(endDate));
        this.isUpdated = true;
        this.getItems();
    }

    onDateInputChanged(event, filterType, type) {
        if (event.value) {
            return;
        }

        this.dateOptionsFilter.from = moment(event.start);
        this.dateOptionsFilter.to = moment(event.end);

        this.isUpdated = true;
        this.getItems();
    }

    setDateRange(option){
        if(option){
            this.dateRangeSelected = option;
            switch(option){
                case 'week':
                    this.dateRangeNumber = moment().isoWeek();
                    break;
                case 'month':
                    this.dateRangeNumber = moment().month();
                    break;
                case 'quarter':
                    this.dateRangeNumber = moment().quarter();
                    break;
                case 'year':
                    this.dateRangeNumber = moment().year();
                    break;
                default:
                    return false;
            }
        }
        return this.navigateDateRange();
    }

    navigateDateRange(number = 0, disable= false){
        if(disable){
            return false;
        }
        this.dateRangeNumber += number;
        switch(this.dateRangeSelected){
            case 'week':
                this.dateOptionsFilter = {
                    from: moment().isoWeek(this.dateRangeNumber).startOf('isoWeek'),
                    to: moment().isoWeek(this.dateRangeNumber).endOf('isoWeek'),
                };
                break;
            case 'month':
                this.dateOptionsFilter = {
                    from: moment().month(this.dateRangeNumber).startOf('month'),
                    to: moment().month(this.dateRangeNumber).endOf('month'),
                };
                break;
            case 'quarter':
                this.dateOptionsFilter = {
                    from: moment().quarter(this.dateRangeNumber).startOf('quarter'),
                    to: moment().quarter(this.dateRangeNumber).endOf('quarter'),
                };
                break;
            case 'year':
                this.dateOptionsFilter = {
                    from: moment().year(this.dateRangeNumber).startOf('year'),
                    to: moment().year(this.dateRangeNumber).endOf('year'),
                };
                break;
            default:
                break;
        }
        this.isUpdated = true;
        return this.getItems();
    }

    sort(column: string, isUpdated = true) {
        this.currentPage = 1;
        super.sort(column, isUpdated);
    }

    resetFilter() {
        this.searchInfo = new ActivityModel();
        this.isUpdated = true;
        this.reset = true;

        this.cdr.detectChanges();
        this.getItems();
        this.reset = false ;
    }

    export(){
        const form = <HTMLFormElement>document.getElementById('frmExport');
        const token = this.authService.user['token'];
        form.action = form.action + '&token=' + token;
        form.action += this.clinicId ? '&clinicId=' + this.clinicId : '';
        form.action += '&startDate=' + this.dateOptionsFilter.from.format('YYYY-MM-DD');
        form.action += '&endDate=' + this.dateOptionsFilter.to.format('YYYY-MM-DD');
        form.action += '&lang=' + localStorage.getItem('language');
        form.action += '&filters=sort-' + this.sortedColumn + '--order-' + this.order;
        document.getElementById('inpDateRange').innerHTML = document.getElementById('date-range-data').innerText;
        form.submit();
    }

    checkAvailableDate(condition?){
        switch (condition) {
            case 'prev':
                return moment(this.minDate).isAfter(this.dateOptionsFilter.from);
            case 'next':
                return moment(this.dateOptionsFilter.to).isAfter(this.today);
        }
    }

    isClinicAdmin(){
        return this.user['role_id'] === this.authService.ROLES.CLINIC_ADMIN;
    }

    isSupperAdmin(){
        return this.user['role_id'] === this.authService.ROLES.SUPER_ADMIN;
    }

    onChangeClinic(value) {
        if(this.clinicId === value){
            return;
        }
        this.clinicId = value;
        this.isUpdated = true;
        this.getItems();
    }
}
